import React from 'react';
import { useTranslation } from 'react-i18next';

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const pages = [];
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  return (
    <div className="flex gap-4 justify-center mt-4">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1 border rounded disabled:opacity-50"
      >
        {t('pagination.previous')}
      </button>

      {pages.map((page) => (
          page === currentPage ? (
            <span
              key={page}
              className="px-3 py-1 border rounded bg-gray-200 text-gray-500 cursor-default"
            >
              {page}
            </span>
          ) : (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className="px-3 py-1 border rounded hover:bg-blue-100 transition"
            >
              {page}
            </button>
          )
        ))}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1 border rounded disabled:opacity-50"
      >
        {t('pagination.next')}
      </button>
    </div>
  );
};
